/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo } from "react";
import { Box, Center, ChakraProps, Text } from "@chakra-ui/react";
import { isMobileOnly, isTablet } from "react-device-detect";
import { useLocation } from "react-router-dom";

import { getGapStyles } from "../../theme/utils";
import { RotationTestIds } from "../../dataTestIds";
import { localRoutes } from "../../config";
import { useOrientation } from "../hooks/useOrientation";
import { useWindowSize } from "../hooks/useWindowSize";
import { RotateSvg } from "../assets/icons";
import { messages } from "../locale";

const acceptedPaths = [localRoutes.getChannel, localRoutes.videoCall];

const isAcceptedPath = (pathname: string) => acceptedPaths.some((path) => pathname.includes(path));

export const RotateDevice = () => {
  const { pathname } = useLocation();
  const { isLandscape } = useOrientation();
  const { height = 1000 } = useWindowSize();

  const shouldShow = useMemo(
    () => isAcceptedPath(pathname) && isMobileOnly && !isTablet && height <= 450 && isLandscape,
    [pathname, isLandscape, height]
  );

  if (!shouldShow) return null;

  return (
    <Center {...Styles}>
      <Box>
        <RotateSvg data-testid={RotationTestIds.svg.file} />
      </Box>
      <Text data-testid={RotationTestIds.text.file}>{messages.rotateDevice.text}</Text>
    </Center>
  );
};

const Styles: ChakraProps = {
  top: 0,
  left: 0,
  w: "100vw",
  h: "100vh",
  position: "fixed",
  zIndex: "overlay",
  flexDir: "column",
  ...getGapStyles("xl", true),
  bg: "sapphireBlue",
  color: "white",
};
